const en = {
  heroTitle: "Bovan Lake",
  home: 'Home',
  contact: 'Contact',
  apartments: 'Apartments',
  about: 'About Bovan Lake',
  more: 'More',
  button: 'Book Now',
  aboutHeader: 'Bovan Lake - Hidden Gem of Eastern Serbia',
  aboutFirstTitle: 'Bovan Lake - Oasis of Peace and Natural Beauty',
  aboutFirstSlide: 'Bovan Lake, hidden in the heart of Serbia, is a true oasis of peace and natural beauty. Located between Aleksinac and Sokobanja, this lake attracts attention with its crystal-clear water and unspoiled nature. It is ideal for those who want to escape from the hustle and bustle of the city and find peace in nature.',
  aboutSecondTitle: 'Artificial Lake with Natural Beauty',
  aboutSecondSlide: 'Although it is an artificial lake formed in 1978 by the construction of a dam on the Moravica River, it can be said to be the natural beauty of Eastern Serbia. It is about eight kilometers long, so for those who cannot afford a seaside trip, it can be an adequate alternative. The dam was built to protect against flooding, but the lake that formed over time has become a center for recreation and tourism.',
  aboutThirdTitle: 'Recreation and Adventure on the Lake',
  aboutThirdSlide: 'When Bovan Lake is first seen, the first thing noticed is the incredible color of the water, which changes from emerald green to deep blue, depending on the light and season. Surrounded by forested hills and lush vegetation, the lake offers numerous opportunities for recreation and adventure, such as fishing, swimming, sailing, kayaking, and cycling.',
  aboutFourthTitle: 'Local Specialties and Enjoying Nature',
  aboutFourthSlide: 'A visit to Bovan Lake is not complete without tasting local specialties. In the nearby villages, you can enjoy homemade products such as cheese, honey, and brandy. Restaurants in the area offer traditional dishes such as lamb cooked under a bell and various types of trout. This is the perfect destination for a combination of adventure, relaxation, and natural beauty.',
  apartmentFeature: "Featured",
  apartmentFrom: "from",
  apartmentPrice: "per night",
  reccomendedTitle: "Recommended Apartments",
  reccomendedDescription: "Discover our carefully selected range of stunning lakeside apartments, each offering a unique experience and breathtaking views.",
  commonQuestionTitle: "Frequently Asked Questions",
  testimonialsTitle: "What Our Guests Say",
  contactTitle: "Contact Us",
  contactSecondTitle: "We are here to help you find the perfect lakeside home.",
  contactName: "Name",
  contactMessage: "Message",
  contactSuccess: "Message sent successfully!",
  contactFail: "There was an error sending your message.",
  contactSending: "Sending...",
  contactSend: "Send Message",
  contactInformation: "Contact Information",
  footerDescription: "Modern apartments at Bovan Lake, offering a peaceful retreat with a beautiful lake view. Family-friendly amenities including a spacious yard, sunbeds, kayak, boat, BBQ, and more for a relaxing stay.",
  footerFirstTitle: "ABOUT",
  footerSecondTitle: "CONTACT INFORMATION",
  footerThirdTitle: "QUICK LINKS",
  welcomeTitle: "Welcome to Lake Life",
  welcomeDescription: "Discover the perfect combination of luxury and nature in our lakeside apartments, where each sunrise brings new possibilities for lakeside living.",
  section1Title: "Bovan Lake: Oasis of Peace and Natural Beauty",
  section1Description: "Hidden in the heart of Serbia, Bovan Lake is the ideal place to escape from the city, with crystal-clear water and unspoiled nature.",
  feature1Title: "Origin and History",
  feature1Description: "An artificial lake formed in 1978 by the construction of a dam on the Moravica River, it is eight kilometers long and offers both recreation and natural beauty in Eastern Serbia.",
  feature2Title: "Water Color and Forests",
  feature2Description: "The incredible water color, ranging from emerald green to deep blue, and the dense forests create the perfect environment for enjoyment.",
  feature3Title: "Recreational Activities",
  feature3Description: "Fishing, swimming, sailing, kayaking, and pedal boating are just some of the activities the lake offers.",
  feature4Title: "Places and Attractions Nearby",
  feature4Description: "Sokobanja is located 17 km from Bella Apartments.\nBella Apartments are 48 km from Niš Airport.",
  
  feature5Title: "Excursion Sites",
  feature5Description: "Lepterija and Soko Grad\nRipaljka Waterfall\nMoravica River Source\nVrmdzansko Lake\nRestaurant 'Etno Vodenica at Grandpa Mija's'\nSesalačka Cave\nBorici Park\nSwimming Beaches on the Moravica River\n'Dzentlmen' Beach",
  
  feature6Title: "Restaurants in Sokobanja",
  feature6Description: "Zelengora\nRestaurant Stanković\nPizzeria Lav\nLa Famiglia Sokobanja\nRestaurant Župan\nRestaurant Milošev Konak\n️Restaurant Stara Vodenica\n️Kafana Kod Kuma\n️Kod Pudle\n️Vodenica at Grandpa Mija's\n️Filotin View",
  section2Title: "Beaches and Surroundings",
  section2Description: "Clear beaches, maintained by local residents, provide a unique environment for relaxation",
  excellenceTitle: "Local Gastronomy",
  excellenceDescription: "Traditional dishes and homemade products such as cheese, honey, and brandy make a visit to Bovan Lake unforgettable.",
  holidayPeriod: "Holiday Period",
  regularPeriod: "In Season Period",
  nonRegularPeriod: "Out Of Season Period",
  holidayDates: ["30.12 - 02.01" , "01.05" , "14.02" , "11.11"], 
  holidayPrice: "€300",
  regularNightPrice: "€50",
  nonRegularNightPrice: "€40",
  weekendPrice: "€130",
  checkIn: "12:00 check-in",
  checkOut: "15:00 check-out",
  weekendTime: "Fri 14:00 - Sun 18:00",
  wifi: "Free WiFi",
  tv: "Satellite TV",
  bbq: "BBQ Available",
  beddingTowels: "Bedding and Towels",
  parking: "Parking",
  bathroomWithHairdryer: "Bathroom with Hairdryer",
  spaciousLiving: "Spacious Living Room",
  max4Adults: "Max 4 Adults",
  lakeView: "Lake View",
  completeKitchen: "Complete Kitchen",
  spaciousTerrace: "Spacious Terrace",
  noParties: "No Parties",
  noPets: "No Pets",
  twoBedrooms: "Two Bedroom Rooms",
  groundFloorApartmentDescription: "Living room with sofa bed, bedroom with double bed, bathroom, kitchen with bar, and lake-view terrace.",
  upperFloorApartmentDescription: "Two bedrooms (double + twin), bathroom, kitchen, and terrace with lake view.",
  firstTestimonialName: "Sara",
  firstTestimonialImage: "first",
  firstTestimonialText: "A beautiful stay at Bovan Lake, the apartments are comfortable and peaceful.",

  secondTestimonialName: "Mihajlo",
  secondTestimonialImage: "second",
  secondTestimonialText: "The perfect place for relaxation, close to nature and the lake.",

  thirdTestimonialName: "Marija",
  thirdTestimonialImage: "third",
  thirdTestimonialText: "I recommend it for a peaceful and comfortable stay in beautiful nature.",

  fourthTestimonialName: "Danilo",
  fourthTestimonialImage: "fourth",
  fourthTestimonialText: "A perfect place for a family vacation, near the lake and nature.",

  amenities: "Featured Amenities",
  aboutProperty: "About This Property",
  groundFloorApartmentTitle: "App Bella Ground Floor",
  upperFloorApartmentTitle: "App Bella First Floor"
};

export default en;
